import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { Field, useField } from 'formik';
import { debounce } from 'lodash';
import emailSpellChecker from '@zootools/email-spell-checker';

export default function EmailInput({ name, value, onChange, disabled, className, ...props }) {
  const [field] = useField(name);

  const [emailSuggestion, setEmailSuggestion] = useState(null);
  const [isFocused, setIsFocused] = useState(false);

  // debounce validation
  const debouncedValidate = React.useCallback(
    debounce(emailInput => {
      const suggestion = emailSpellChecker.run({
        email: emailInput,
      });

      if (suggestion) {
        setEmailSuggestion(suggestion.full);
      } else {
        setEmailSuggestion(null);
      }
    }, 500),
    [],
  );

  useEffect(() => {
    if (!field.value) return;

    debouncedValidate(field.value);
  }, [field.value, isFocused]);

  return (
    <>
      <input
        type="email"
        className={clsx(
          'appearance-none block w-full py-1.5 px-2 text-gray-800 rounded border-none shadow-input focus:shadow-input-focus',
          { 'opacity-50': disabled },
          className,
        )}
        disabled={disabled}
        value={value}
        onChange={e => onChange(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        {...props}
      />

      {emailSuggestion && (
        <p className="mt-2 text-sm text-right">
          Did you mean{' '}
          <button
            onClick={() => {
              onChange(emailSuggestion);
              setEmailSuggestion(null);
            }}
            className="font-medium underline"
            type="button"
          >
            {emailSuggestion}
          </button>
          ?
        </p>
      )}
    </>
  );
}

export const EmailField = props => {
  // eslint-disable-next-line no-unused-vars
  const [field, meta, helpers] = useField(props);

  const { setValue } = helpers;

  return (
    <Field
      {...props}
      as={EmailInput}
      onChange={value => {
        setValue(value);
      }}
      value={field.value}
    />
  );
};
